/// <reference types="bootstrap"/>
import BootstrapCollapse from 'bootstrap/js/dist/collapse';
class Collapse {
    constructor(config) {
        this.config = config;
        this.run();
    }
    run() {
        this.instance = this.createInstance(this.config.element);
    }
    createInstance(triggerEl) {
        return new BootstrapCollapse(triggerEl, { toggle: false });
    }
    getInstance() {
        return this.instance;
    }
}
export { Collapse };
